"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourcePipe = void 0;
/**
 * Returned from {@link ObjectResourceStore.load}. Allows resources to be piped through
 * one or more processing stages, async or sync. The primary use case is image filters:
 * brightness, contrast, saturation, etc.
 *
 * Example usage:
 *
 * ```
 * store
 *     .load("image:source", () => this.loadImage(object.url), {hash: object.url})
 *     .pipe("image:filtered", i => this._filter(i, object), {hash: this._hashFilters(object)});
 * ```
 */
var ResourcePipe = /** @class */ (function () {
    function ResourcePipe(_store, _inputResource) {
        this._store = _store;
        this._inputResource = _inputResource;
    }
    /**
     * Adds a processing stage to the resource that was just registered.
     *
     * @param key The key identifying the processed resource.
     * @param process Called to process the input resource if needed.
     * @param caching Specifies caching options.
     * @param caching.hash A hash value to compare against a previous call.
     */
    ResourcePipe.prototype.pipe = function (key, process, caching) {
        var _this = this;
        var callback = function () {
            return _this._inputResource.promise.then(function (input) {
                var result = process(input);
                return _this._assertPromise(key, result);
            });
        };
        return this._store.load(key, callback, {
            hash: this._inputResource.hash + caching.hash
        });
    };
    /**
     * Throws an error when a processing stage does not return a promise. This catches common mistakes
     * like forgetting to return a value (which can cause hard-to-debug failures).
     */
    ResourcePipe.prototype._assertPromise = function (key, value) {
        if (!value.then || !value.catch) {
            throw new Error("Processing stage for '" + key + "' did not return a promise. If the processing "
                + "stage is not async, you should return `Promise.resolve(result)`.");
        }
        return value;
    };
    return ResourcePipe;
}());
exports.ResourcePipe = ResourcePipe;
//# sourceMappingURL=ResourcePipe.js.map